import { loadLocale } from '@/api/locale';
import { logError } from "@/utils/appLogger";

const getLocale = (context) => {
  loadLocale()
    .then(({ data, status }) => {
      if (status === 200) {
        context.commit('setLocale', data);
      } else {
        logError('Something wrong with locale');
      }
    });
}

export default {
  getLocale
}
